import { useState } from 'react';

import { faFileLines } from '@fortawesome/free-regular-svg-icons';
import {
  faArrowRightFromBracket,
  faGear,
  faLanguage,
  faShieldHalved,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import {
  Avatar,
  AvatarFallback,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@repo/videa-components/src';
import { useSetAtom } from 'jotai';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { usePreferences } from '@/react-query/usePreferences';

import { isPreferenceMenuOpen } from '../../app/appHeader/atoms';
import { PracticePreferencesMenu } from '../../app/appHeader/practicePreferencesMenu/PracticePreferencesMenu';
import { useHandleLogout } from '../../app/appHeader/utils';
import { PRIVACY_POLICY_PDF_URL } from '../../common-components/composed/pdfReader/pdfConstants';
import { PdfReader } from '../../common-components/composed/pdfReader/PdfReader';
import {
  LocalePicker,
  isLocalePickerOpenAtom,
} from '../../locales/localePicker';
import routesConstants from '../../routes/routes.constants';
import { useIsEmbedded } from '../../utils/hooks';
export const AccountDropdown = () => {
  const setIsPracticePreferencesOpen = useSetAtom(isPreferenceMenuOpen);
  const setIsLocalePickerOpen = useSetAtom(isLocalePickerOpenAtom);
  const { data: prefs } = usePreferences();

  const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = useState(false);

  const { logout } = useHandleLogout();
  const history = useHistory();
  const isEmbedded = useIsEmbedded();
  const user = useSelector((state: any) => state?.login?.user);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          className="vai-bg-transparent vai-border-none vai-p-0 vai-cursor-pointer"
          data-testid="account-dropdown"
        >
          <Avatar className="!vai-rounded-sm vai-w-8 vai-h-8">
            <AvatarFallback className="vai-bg-violet-700 vai-text-white vai-uppercase !vai-rounded-sm vai-text-base vai-font-medium">
              {user.username ? user.username.substring(0, 2) : ''}
            </AvatarFallback>
          </Avatar>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="vai-font-inter">
          {!prefs.enableVoiceNotesStandalone && (
            <DropdownMenuItem
              data-testid="preferences-menu-item"
              className="vai-cursor-pointer"
              onClick={() => setIsPracticePreferencesOpen(true)}
            >
              <FontAwesomeIcon icon={faGear} /> <Trans>Preferences</Trans>
            </DropdownMenuItem>
          )}
          {prefs.localeSwitcherEnabled && (
            <DropdownMenuItem
              className="vai-cursor-pointer"
              onClick={() => setIsLocalePickerOpen(true)}
            >
              <FontAwesomeIcon icon={faLanguage} /> <Trans>Language</Trans>
            </DropdownMenuItem>
          )}
          <DropdownMenuSeparator />
          <DropdownMenuItem
            className="vai-cursor-pointer"
            onClick={() => setIsPrivacyPolicyOpen(true)}
            data-testid="privacy-policy-menu-item"
          >
            <FontAwesomeIcon icon={faShieldHalved} />{' '}
            <Trans>Privacy Policy</Trans>
          </DropdownMenuItem>
          <DropdownMenuItem
            className="vai-cursor-pointer"
            onClick={() => {
              const aboutRoute = isEmbedded
                ? `/embedded${routesConstants.ABOUT}`
                : routesConstants.ABOUT;
              history.push(aboutRoute);
            }}
            data-testid="about-menu-item"
          >
            <FontAwesomeIcon icon={faFileLines} /> <Trans>About</Trans>
          </DropdownMenuItem>
          {!isEmbedded && (
            <DropdownMenuItem
              className="vai-cursor-pointer"
              onClick={() => logout(true, { logoutType: 'MANUAL' })}
              data-testid="logout-button"
            >
              <FontAwesomeIcon icon={faArrowRightFromBracket} />{' '}
              <Trans>Log Out</Trans>
            </DropdownMenuItem>
          )}
          <DropdownMenuSeparator />
          <DropdownMenuLabel className="vai-text-end !vai-font-normal">
            V{process.env.VITE_VERSION}
          </DropdownMenuLabel>
        </DropdownMenuContent>
      </DropdownMenu>
      <PdfReader
        isOpen={isPrivacyPolicyOpen}
        toggleViewer={() => setIsPrivacyPolicyOpen(!isPrivacyPolicyOpen)}
        pdfUrl={PRIVACY_POLICY_PDF_URL}
      />
      <PracticePreferencesMenu />
      <LocalePicker />
    </>
  );
};
